import Slider from "react-slick";
import { useCmsSlider } from "../context/CmsSliderContext";

export default function CmsSlider({ settings, slides }) {
  const { setIsOpenSlider } = useCmsSlider();
  
  return (
    <Slider {...settings}>
      {
        slides.map((item, index) => (
          <div
            className="px-[10px] min-[625px]:px-5 w-auto cursor-pointer"
            onClick={() => {
              setIsOpenSlider({ show: true, index, slides });
            }}
          >
            <img
              className="inline-block object-cover w-auto"
              src={item}
              alt="Brand Logo"
            />
          </div>
        ))}
    </Slider>
  );
}
